import type { CSSObject } from '@emotion/react'
import { Color, Spacing, Typography } from '@opallabs/gem'
import type { WithRequiredTheme } from '@opallabs/lapidary'

type StyleProps = WithRequiredTheme

export const timeContainer = ({ theme }: StyleProps): CSSObject => ({
  color: Color[theme].Text.Gray,
  ...Typography.M500,
  display: 'flex',
  lineHeight: '24px',
  marginInlineEnd: Spacing.S,
  marginInlineStart: Spacing.S,
})

export const timestamp: CSSObject = {
  lineHeight: 'inherit',
}

export const timezone: CSSObject = {
  display: 'flex',
  marginInlineStart: '1em',
}
